import React from "react";
import {AutoComplete, Checkbox, Input, InputNumber, Select} from "antd";

// The controls of a flat's fields by their kind (the card and the table's cells and mass edit), and a value as a control
// holds it and back.

export const groupDigits = (text) => text.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
export const formatNumber = (value) => {
  if (value === null || value === undefined || value === '') return ''
  const [whole, fraction] = String(value).split('.')
  return fraction !== undefined ? `${groupDigits(whole)}.${fraction}` : groupDigits(whole)
}
export const parseNumber = (text) => String(text || '').replace(/\s/g, '').replace(',', '.')
// the flat's value as the form holds it, and back
export const toForm = (kind, value) => {
  switch (kind) {
    case 'int':
    case 'number':
      return value === null || value === undefined ? null : Number(value)
    case 'bool':
      return value === null || value === undefined ? undefined : String(Boolean(value))
    case 'date':
      return value ? String(value).slice(0, 10) : ''
    case 'list':
    case 'ids':
    case 'features':
      return Array.isArray(value) ? value : []
    // { "0": [lat1, lon1, lat2, lon2], … } → [[…], …]
    case 'arrows':
      return value && typeof value === 'object' ? Object.values(value).filter(Array.isArray) : []
    default:
      return value === null || value === undefined ? '' : String(value)
  }
}
export const fromForm = (kind, value) => {
  switch (kind) {
    case 'int':
    case 'number':
      return value === null || value === undefined || value === '' ? null : Number(value)
    case 'bool':
      return value === 'true' ? true : value === 'false' ? false : null
    case 'list': {
      const list = (value || []).map((v) => String(v).trim()).filter(Boolean)
      return list.length ? list : null
    }
    case 'ids':
    case 'features':
      return value && value.length ? [...value].map(Number).sort((a, b) => a - b) : null
    case 'arrows':
      return Array.isArray(value) && value.length ? value : null
    default: {
      const text = String(value === null || value === undefined ? '' : value).trim()
      return text || null
    }
  }
}
// a select of ECI old's list (meta.lists): its names, the stored values; a value the list has not keeps its place
export const ListSelect = ({list, kind, value, onChange, disabled, single, ...rest}) => {
  const asForm = (v) => (kind === 'bool' ? String(v) : v)
  let options = list.map((o) => (o.options
    ? {label: o.label, options: o.options.map((c) => ({label: c.label, value: asForm(c.value)}))}
    : {label: o.label, value: asForm(o.value)}))
  const flat = options.flatMap((o) => o.options || [o])
  const current = kind === 'list' ? (value || []) : value === undefined || value === null || value === '' ? [] : [value]
  current.filter((v) => !flat.some((o) => o.value === v)).forEach((v) => {
    options = [...options, {label: kind === 'bool' ? (v === 'true' ? 'Да' : 'Нет') : String(v), value: v}]
  })
  // «Парковка» is one choice on ECI old, kept as a list
  if (kind === 'list' && single) {
    return <Select allowClear showSearch optionFilterProp='label' placeholder='Выберите' options={options} disabled={disabled}
      {...rest} value={(value || [])[0]} onChange={(v) => onChange(v ? [v] : [])}/>
  }
  return (
    <Select allowClear showSearch optionFilterProp='label' placeholder='Выберите' options={options} disabled={disabled}
      {...rest} mode={kind === 'list' ? 'multiple' : undefined} value={kind === 'list' ? value : value || undefined} onChange={onChange}/>
  )
}

// «Вид из окон» of the feed: ECI old's text «На улицу | Во двор» as two ticks (the staff, 27.10: several can be true)
const WINDOWS = ['На улицу', 'Во двор']
export const WindowsControl = ({value, onChange, disabled}) => {
  const text = String(value || '').toLowerCase()
  const checked = WINDOWS.filter((w) => (w === 'На улицу' ? /улиц/.test(text) : /двор/.test(text)))
  return <Checkbox.Group options={WINDOWS} value={checked} disabled={disabled} onChange={(list) => onChange(WINDOWS.filter((w) => list.includes(w)).join(' | '))}/>
}

// plain: a field of the old form (one line unless area, no hints); otherwise «Прочие поля» as before
export const FieldControl = ({field, list, references, disabled, plain, area, ...rest}) => {
  const {kind, options = []} = field
  if (field.key === 'windowsDirection') return <WindowsControl disabled={disabled} {...rest}/>
  if (list) return <ListSelect list={list} kind={kind} disabled={disabled} single={field.key === 'parking'} {...rest}/>
  if (kind === 'long' && plain && !area) return <Input disabled={disabled} {...rest}/>
  if (kind === 'long') return <Input.TextArea autoSize={{minRows: area ? 4 : 1, maxRows: 10}} disabled={disabled} {...rest}/>
  if (kind === 'int' || kind === 'number') {
    return <InputNumber style={{width: '100%'}} disabled={disabled} formatter={formatNumber} parser={parseNumber} precision={kind === 'int' ? 0 : undefined} {...rest}/>
  }
  if (kind === 'bool') {
    return <Select allowClear placeholder='Выберите' disabled={disabled} options={[{value: 'true', label: 'Да'}, {value: 'false', label: 'Нет'}]} {...rest}/>
  }
  if (kind === 'date') return <Input type='date' disabled={disabled} {...rest}/>
  if (kind === 'curator') return <Select allowClear showSearch optionFilterProp='label' placeholder='Не назначен' options={references.curators} disabled={disabled} {...rest}/>
  if (kind === 'ids') return <Select mode='multiple' allowClear optionFilterProp='label' placeholder='Не в подборках' options={references.selections} disabled={disabled} {...rest}/>
  if (kind === 'features') return <Select mode='multiple' allowClear optionFilterProp='label' placeholder='Нет особенностей' options={references.features} disabled={disabled} {...rest}/>
  if (kind === 'list') {
    return <Select mode='tags' allowClear tokenSeparators={[',']} placeholder='Выберите или впишите' options={options.map((value) => ({value}))} disabled={disabled} {...rest}/>
  }
  // the old form's own inputs are plain; «Прочие поля» keep the portal's hints
  if (options.length && !plain) {
    return (
      <AutoComplete allowClear options={options.map((value) => ({value}))} placeholder='Выберите или впишите' disabled={disabled}
        filterOption={(input, option) => String(option.value).toLowerCase().includes(String(input).toLowerCase())} {...rest}/>
    )
  }
  return <Input disabled={disabled} {...rest}/>
}
